import React from "react";

const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedSeconds = remainingSeconds.toFixed(2).padStart(5, "0");
    return `${minutes}:${formattedSeconds}`;
};

interface TimeDisplayProps {
    currentTime: number;
    duration: number;
}
export const TimeDisplay: React.FC<TimeDisplayProps> = ({ currentTime, duration }) => {
    return (
        <div className="flex items-center text-[10px] md:text-sm">
            <span>{formatTime(currentTime)}</span>
            <span className="mx-2">/</span>
            <span>{formatTime(duration)}</span>
        </div>
    );
};
